'use client';

import React from 'react';
import Image from 'next/image';
import styles from './DivOne.module.scss';
import StyledButton from '@/src/components/StyledButton/StyledButton';

interface Props {
    imageUrl: string;
    subheading: string;
    title: string;
    text: string;
    buttonLabel: string;
    buttonUrl: string;
}

const DivOne = ({ imageUrl, subheading, title, text, buttonLabel, buttonUrl }: Props) => {
    return (
        <section className={styles.divOne} aria-labelledby="divOne-heading">
            <div className={styles.container}>
                <div className={styles.imageWrapper}>
                    <Image
                        src={imageUrl}
                        alt={title}
                        width={600}
                        height={400}
                        className={styles.image}
                        priority={false}
                    />
                </div>
                <div className={styles.content}>
                    <p className={styles.subheading}>{subheading}</p>
                    <h2 id="divOne-heading" className={styles.title}>
                        {title}
                    </h2>
                    <p className={styles.text}>{text}</p>
                    <StyledButton href={buttonUrl}>{buttonLabel}</StyledButton>
                </div>
            </div>
        </section>
    );
};

export default DivOne;
